import { ConnectedProps, connect } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Avatar } from 'antd';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { RootState } from 'src/redux/store';
import styles from './style.module.scss';

const connector = connect(({ user }: RootState) => ({ user }));

interface ProfileMenuProps extends ConnectedProps<typeof connector> {}
class TopBarProfileMenu extends React.Component<ProfileMenuProps> {
  logout = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'user/LOGOUT',
    });
  };

  render() {
    const { user } = this.props;
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <strong>
            <FormattedMessage id="topBar.profileMenu.hello" />, {user.name || 'Anonymous'}
          </strong>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <a href="javascript: void(0);" onClick={this.logout}>
            <i className={`${styles.menuIcon} icmn-exit`} />
            <FormattedMessage id="topBar.profileMenu.logout" />
          </a>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <div className={styles.dropdown} style={{ left: '87%' }}>
          <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
        </div>
      </Dropdown>
    );
  }
}

export const ProfileMenu = connector(TopBarProfileMenu);
